var _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardBronze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 540,
    r: 420,
    fill: "#B87333",
    stroke: "#15273f",
    strokeWidth: 24
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 620,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 320,
    fontWeight: 700,
    fill: "#15273f"
  }, "B")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardBronze);
export default __webpack_public_path__ + "static/media/reward-bronze.352d69ea9a8191dc0a65c617ea012c54.svg";
export { ForwardRef as ReactComponent };